module.exports = __webpack_public_path__ + "img/2.fdabd4c6.png";